import React from "react";
import CheckGreen from "../images/check-icon.png";
import CancelIcon from "../images/cancel-icon.png";

export default function CheckRibon(props) {
  return (
    <div className="ribon-information-v2">
      {props.check ? <img alt="" src={CheckGreen} /> : <img alt="" src={CancelIcon} />}
      <div className="title-ribon"> {props.labelContent}</div>
    </div>
  );
}
